module.exports = __webpack_public_path__ + "img/A58A1209.c26f6c97.jpg";